Greenmile.Tag = Greenmile.Tag || {};

const typeText = 'TextField';
const typeDecimal = 'Decimal';
const typeNumber = 'Number';
const typeDate = 'DateField';
const typeDateTime = 'DateTimeField';
const typeCheckbox = 'Checkbox';

const mountObj = (text, type) => ({ text, type });

Greenmile.Tag.AutoCompleteTags = {
    possibleRestrictions: [
        mountObj('', typeText),
        mountObj('Equipment.key', typeText),
        mountObj('Equipment.description', typeText),
        mountObj('Equipment.equipmentType.key', typeText),
        mountObj('Equipment.equipmentType.description', typeText),
        mountObj('Equipment.equipmentType.weight', typeDecimal),
        mountObj('Equipment.equipmentType.height', typeDecimal),
        mountObj('Equipment.equipmentType.size1', typeDecimal),
        mountObj('Equipment.equipmentType.size2', typeDecimal),
        mountObj('Equipment.equipmentType.size3', typeDecimal),
        mountObj('Stop.key', typeText),
        mountObj('Stop.location.key', typeText),
        mountObj('Stop.location.accountType.key', typeText),
        mountObj('Stop.location.accountType.description', typeText),
        mountObj('Stop.location.locationType.key', typeText),
        mountObj('Stop.location.locationType.description', typeText),
        mountObj('Stop.location.timeWindowType.key', typeText),
        mountObj('Stop.location.timeWindowType.description', typeText),
        mountObj('Stop.location.serviceTimeType.key', typeText),
        mountObj('Stop.location.serviceTimeType.description', typeText),
        mountObj('Stop.location.description', typeText),
        mountObj('Stop.location.addressLine1', typeText),
        mountObj('Stop.location.addressLine2', typeText),
        mountObj('Stop.location.city', typeText),
        mountObj('Stop.location.state', typeText),
        mountObj('Stop.location.zipCode', typeText),
        mountObj('Stop.location.district', typeText),
        mountObj('Stop.location.longitude', typeText),
        mountObj('Stop.location.latitude', typeText),
        mountObj('Stop.location.phone1', typeText),
        mountObj('Stop.location.phone1Type', typeText),
        mountObj('Stop.location.phone2', typeText),
        mountObj('Stop.location.phone2Type', typeText),
        mountObj('Stop.location.email', typeText),
        mountObj('Stop.location.deliveryInstructions', typeText),
        mountObj('Stop.baseLineSequenceNum', typeNumber),
        mountObj('Stop.plannedSequenceNum', typeNumber),
        mountObj('Stop.actualSequenceNum', typeNumber),
        mountObj('Stop.stopType.description', typeText),
        mountObj('Stop.baseLineArrival', typeDateTime),
        mountObj('Stop.plannedArrival', typeDateTime),
        mountObj('Stop.projectedArrival', typeDateTime),
        mountObj('Stop.actualArrival', typeDateTime),
        mountObj('Stop.baseLineService', typeDateTime),
        mountObj('Stop.plannedService', typeDateTime),
        mountObj('Stop.projectedService', typeDateTime),
        mountObj('Stop.actualService', typeDateTime),
        mountObj('Stop.baseLineDeparture', typeDateTime),
        mountObj('Stop.plannedDeparture', typeDateTime),
        mountObj('Stop.projectedDeparture', typeDateTime),
        mountObj('Stop.actualDeparture', typeDateTime),
        mountObj('Stop.baseLineDistance', typeDecimal),
        mountObj('Stop.plannedDistance', typeDecimal),
        mountObj('Stop.projectedDistance', typeDecimal),
        mountObj('Stop.actualDistance', typeDecimal),
        mountObj('Stop.baseLineSize1', typeDecimal),
        mountObj('Stop.baseLineSize2', typeDecimal),
        mountObj('Stop.baseLineSize3', typeDecimal),
        mountObj('Stop.plannedSize1', typeDecimal),
        mountObj('Stop.plannedSize2', typeDecimal),
        mountObj('Stop.plannedSize3', typeDecimal),
        mountObj('Stop.actualSize1', typeDecimal),
        mountObj('Stop.actualSize2', typeDecimal),
        mountObj('Stop.actualSize3', typeDecimal),
        mountObj('Stop.plannedPickupSize1', typeDecimal),
        mountObj('Stop.plannedPickupSize2', typeDecimal),
        mountObj('Stop.plannedPickupSize3', typeDecimal),
        mountObj('Stop.baseLinePickupSize1', typeDecimal),
        mountObj('Stop.baseLinePickupSize2', typeDecimal),
        mountObj('Stop.baseLinePickupSize3', typeDecimal),
        mountObj('Stop.actualPickupSize1', typeDecimal),
        mountObj('Stop.actualPickupSize2', typeDecimal),
        mountObj('Stop.actualPickupSize3', typeDecimal),
        mountObj('Stop.damagedSize1', typeDecimal),
        mountObj('Stop.damagedSize2', typeDecimal),
        mountObj('Stop.damagedSize3', typeDecimal),
        mountObj('Stop.deliveryReasonCode.description', typeText),
        mountObj('Stop.overReasonCode.description', typeText),
        mountObj('Stop.shortReasonCode.description', typeText),
        mountObj('Stop.damagedReasonCode.description', typeText),
        mountObj('Stop.pickupReasonCode.description', typeText),
        mountObj('Stop.cancelCode.description', typeText),
        mountObj('Stop.undeliverableCode.description', typeText),
        mountObj('Stop.arrivalLatitude', typeText),
        mountObj('Stop.arrivalLongitude', typeText),
        mountObj('Stop.arrivalAccuracyMeters', typeNumber),
        mountObj('Stop.arrivedInTimeWindow', typeCheckbox),
        mountObj('Stop.serviceLatitude', typeText),
        mountObj('Stop.serviceAccuracyMeters', typeNumber),
        mountObj('Stop.serviceLongitude', typeText),
        mountObj('Stop.longitude', typeText),
        mountObj('Stop.latitude', typeText),
        mountObj('Route.date', typeDate),
        mountObj('Route.key', typeText),
        mountObj('Route.description', typeText),
        mountObj('Route.origin.key', typeText),
        mountObj('Route.origin.description', typeText),
        mountObj('Route.origLatitude', typeText),
        mountObj('Route.origLongitude', typeText),
        mountObj('Route.destination.key', typeText),
        mountObj('Route.destLatitude', typeText),
        mountObj('Route.destLongitude', typeText),
        mountObj('Route.destination.description', typeText),
        mountObj('Route.baseLineArrival', typeDateTime),
        mountObj('Route.baseLineDeparture', typeDateTime),
        mountObj('Route.plannedArrival', typeDateTime),
        mountObj('Route.plannedDeparture', typeDateTime),
        mountObj('Route.projectedArrival', typeDateTime),
        mountObj('Route.projectedDeparture', typeDateTime),
        mountObj('Route.actualArrival', typeDateTime),
        mountObj('Route.actualDeparture', typeDateTime),
        mountObj('Route.baseLineDistance', typeDecimal),
        mountObj('Route.plannedDistance', typeDecimal),
        mountObj('Route.projectedDistance', typeDecimal),
        mountObj('Route.actualDistance', typeDecimal),
        mountObj('Route.baseLineComplete', typeDateTime),
        mountObj('Route.plannedComplete', typeDateTime),
        mountObj('Route.projectedComplete', typeDateTime),
        mountObj('Route.actualComplete', typeDateTime),
        mountObj('Route.baseLineCost', typeNumber),
        mountObj('Route.plannedCost', typeNumber),
        mountObj('Route.actualCost', typeNumber),
        mountObj('Route.baseLineStart', typeDateTime),
        mountObj('Route.plannedStart', typeDateTime),
        mountObj('Route.projectedStart', typeDateTime),
        mountObj('Route.actualStart', typeDateTime),
        mountObj('Route.hasHelper', typeCheckbox),
        mountObj('Route.totalStops', typeNumber),
        mountObj('Route.canceledStops', typeNumber),
        mountObj('Route.undeliveredStops', typeNumber),
        mountObj('Route.redeliveredStops', typeNumber),
        mountObj('Route.actualTravelTimeMinutes', typeNumber),
        mountObj('Route.plannedTravelTimeMinutes', typeNumber),
        mountObj('Route.baselineTravelTimeMinutes', typeNumber),
        mountObj('Route.hasPicture', typeCheckbox),
        mountObj('Order.number', typeText),
        mountObj('Order.plannedSize1', typeDecimal),
        mountObj('Order.plannedSize2', typeDecimal),
        mountObj('Order.plannedSize3', typeDecimal),
        mountObj('Order.actualSize1', typeDecimal),
        mountObj('Order.actualSize2', typeDecimal),
        mountObj('Order.actualSize3', typeDecimal),
        mountObj('Order.plannedPickupSize1', typeDecimal),
        mountObj('Order.plannedPickupSize2', typeDecimal),
        mountObj('Order.plannedPickupSize3', typeDecimal),
        mountObj('Order.actualPickupSize1', typeDecimal),
        mountObj('Order.actualPickupSize2', typeDecimal),
        mountObj('Order.actualPickupSize3', typeDecimal),
        mountObj('Order.damagedSize1', typeDecimal),
        mountObj('Order.damagedSize2', typeDecimal),
        mountObj('Order.damagedSize3', typeDecimal),
        mountObj('Order.deliveryReasonCode.description', typeText),
        mountObj('Order.overReasonCode.description', typeText),
        mountObj('Order.shortReasonCode.description', typeText),
        mountObj('Order.damagedReasonCode.description', typeText),
        mountObj('Order.pickupReasonCode.description', typeText),
        mountObj('Order.salesMan.key', typeText),
        mountObj('Order.selector', typeText),
        mountObj('Order.salesMan.name', typeText),
        mountObj('HoursOfService.onDuty', typeDateTime)
    ]
};